module.exports = __webpack_public_path__ + "img/we_5.c272e1e9.svg";